<div class="d-flex">
  <span *ngIf="textPosition == 'start-line'" class="warning-hint align-warning-end">{{
    eSignHint
  }}</span>
  <div [formGroup]="eSignForm" *ngIf="eSignForm" class="esignComponent">
    <mat-form-field appearance="fill">
      <mat-label>{{
        state === activeSignatureState || state === inactiveSignatureState
          ? 'e-Signed by You'
          : state === otherSignatureState
          ? 'e-Signed by ' + signedType.signoffName
          : eSignatureAvailable
          ? 'e-Signature PIN'
          : eSignatureAvailChecked
          ? 'No Active E-signature'
          : 'Checking e-Sign Status'
      }}</mat-label>
      <input
        sdNumbersOnlyAlt
        matInput
        class="pin-input"
        type="text"
        style="-webkit-text-security: disc"
        maxlength="4"
        autocomplete="off"
        placeholder="Enter pin"
        formControlName="pinNumber"
      />
      <mat-icon
        matPrefix
        [ngClass]="{
          signatureExists:
            state === activeSignatureState ||
            state === inactiveSignatureState ||
            state === otherSignatureState ||
            state === sigUpdateState,
          cancelButton: state === voidState,
          disableButton: !eSignatureAvailChecked || !eSignatureAvailable
        }"
        [matTooltip]="
          state === activeSignatureState ||
          state === inactiveSignatureState ||
          state === otherSignatureState
            ? 'Signed'
            : state === voidState
            ? 'Void In Progress'
            : eSignatureAvailable
            ? 'Not Signed'
            : 'Unable to sign without an e-Signature'
        "
        matTooltipPosition="above"
        matTooltipShowDelay="500"
        >{{
          state === voidState
            ? 'assignment_late'
            : state !== notSignedState
            ? 'assignment_turned_in'
            : 'assignment'
        }}</mat-icon
      >
      <mat-hint
        *ngIf="state !== notSignedState"
        align="end"
        (click)="revisionClick()"
        [ngClass]="{
          'link-text': hasHistory === true
        }"
        >{{
          'Revision ' +
            signedType.revisionNumber +
            ' on ' +
            (signedType.signoffDate | momentDate : 'M/D/YYYY')
        }}</mat-hint
      >
      <mat-hint
        (click)="voidAndCorrectClick()"
        *ngIf="hasWriteAccess && eSignatureAvailable && state !== notSignedState"
        align="Start"
        class="link-text"
        >{{ state !== voidState ? 'Void the e-signature ' : 'Cancel Void the e-signature' }}
      </mat-hint>
      <mat-hint
        (click)="promptLeaveToProfile()"
        *ngIf="eSignatureAvailChecked && !eSignatureAvailable"
        align="Start"
        class="link-text"
        >{{ 'You do not have an active e-Signature setup.  Click here to create one.' }}
      </mat-hint>

      <button
        matSuffix
        mat-raised-button
        type="button"
        color="primary"
        *ngIf="state === notSignedState && !confirmInProgress"
        [disabled]="disabled || !eSignForm.valid || !eSignForm.dirty"
        (click)="confirmSigning()"
      >
        e-Sign
      </button>
      <button
        matSuffix
        mat-raised-button
        type="button"
        color="primary"
        *ngIf="state === inactiveSignatureState && eSignatureAvailable && !confirmInProgress"
        (click)="confirmSignatureUpdate()"
      >
        Update Signature
      </button>
      <button
        matSuffix
        mat-raised-button
        type="button"
        color="primary"
        *ngIf="confirmInProgress"
        [disabled]="
          disabled || (!eSignForm.valid && (state === sigUpdateState || state === voidState))
        "
        (click)="confirmClick()"
      >
        Confirm
      </button>
      <button
        matSuffix
        mat-raised-button
        type="button"
        *ngIf="confirmInProgress"
        (click)="cancelClick()"
      >
        Cancel
      </button>
    </mat-form-field>
  </div>
  <sd-esignature-revisions
    *ngIf="showHistory && archives"
    [archives]="archives"
    [category]="signCategory"
    class="esignComponent"
  >
  </sd-esignature-revisions>
  <span *ngIf="textPosition == 'end-line'" class="warning-hint align-warning-start">{{
    eSignHint
  }}</span>
</div>
<span *ngIf="textPosition == 'below'" class="warning-hint align-warning-start">{{
  eSignHint
}}</span>
